import React, { useEffect, useState } from "react";
import { Text, View } from "../../shared/Themed";
import { DataTable } from "react-native-paper";
import * as Services from "../../../utils/common";
import { Badge } from "@react-native-material/core";
import { Alert, StyleSheet } from "react-native";

import Icon from "react-native-vector-icons/FontAwesome5";
import { ScrollView, TouchableOpacity } from "react-native-gesture-handler";
import Spinner from "../../shared/Spinner";

import { default as statusColorCodes } from "../../../utils/constants/statusColorCodes";
import { ReadOnlyProps } from "../../../utils/templates";
import { NestedDataTable } from "./NestedDataTableWithPagination";
import { formatValueAsDataType } from "../../../utils/common";
import { NoDataBanner } from "../../shared/NoDataBanner";
import { MaterialCommunityIcons, SimpleLineIcons } from "@expo/vector-icons";
import CustomProgressBar from "../../../screens/ItemTracker/utils/CustomProgressBar";
import {
  Menu,
  MenuOptions,
  MenuOption,
  MenuTrigger,
} from "react-native-popup-menu";
import DeliveryProgressBar from "../../../screens/ItemTracker/utils/CustomDeliveryBar";
import OrderStatusHelp from "./tracker/OrderStatusModal";

interface Props {
  headers: any;
  rows: Array<any>;
  itemsPerPage: number;
  useModal: boolean;
  isDataLoading?: boolean;
  isDisplayTimeWithDate?: boolean;
  setModalVisible: (event: any) => void;
  setDeliveryModalVisible?: any;
  setDeliveryStatusModal?: any;
  handleRowClick: (event: any) => void;
  setSelected: (event: any) => void;
  setSelectedDeliveryItem?: (event: any) => void;

  //Nested Table Variables
  rowKeyValue?: string;
  nestedItemKeyValue?: string;
  nestedHeader?: any;
  isRowsExpandable?: boolean;
  isNestedDataLoaded?: boolean;
  isToExpandAllRows?: boolean;

  isDetail?: boolean; //Control Modal variable
  isEdit?: boolean; //Edit Button variable
  isDelete?: boolean; //Delete Button variable
  isSubDetail?: boolean; //Control Sub Modal variable
  handleDeleteRow: (id: string | number) => void;

  //exclude column to not have thousand separator format
  columnsToNotHaveThousandSeparator?: Array<string>;

  //handle sorting
  handleSortColumn?: (columnKey: string) => void;
  handleNestedSortColumn?: (
    columnKey: string,
    columnParentIdentifier: string
  ) => void;

  operationsScreen?: boolean;
  disableHeader?: boolean;
  operationActions?: (order: any, action: string) => void;
  navigatePressAction?: (filterField: string, filterValue: string) => void;
  isDeliveryAttachment?: boolean;
  showAttachmentIcon?: boolean;
  hideInfoIcon?: boolean;
  itemTracker?: boolean;
  selectable?: boolean;
}

export const DataTableWithPagination: React.FC<ReadOnlyProps<Props>> = ({
  headers,
  rows,
  itemsPerPage,
  useModal,
  nestedHeader,
  rowKeyValue,
  nestedItemKeyValue,
  isDisplayTimeWithDate = false,
  isDataLoading = false,
  isRowsExpandable = false,
  isNestedDataLoaded = false,
  isToExpandAllRows = false,
  setModalVisible,
  setDeliveryModalVisible,
  setDeliveryStatusModal,
  handleRowClick,
  setSelected,
  isDetail = false,
  isSubDetail = false,
  isEdit = false,
  isDelete = false,
  handleDeleteRow,
  columnsToNotHaveThousandSeparator,
  handleSortColumn,
  handleNestedSortColumn,
  operationsScreen,
  disableHeader,
  operationActions,
  isDeliveryAttachment = false,
  showAttachmentIcon = true,
  hideInfoIcon = false,
  setSelectedDeliveryItem,
  itemTracker = false,
  navigatePressAction,
  selectable = false,
}: ReadOnlyProps<Props>) => {
  const [currentRow, setCurrentRow] = useState<string>("");
  const [expandRow, setExpandRow] = useState<boolean>(false);
  const [expandAllRows, setExpandAllRows] = useState<boolean>(false);
  const [_itemsPerPage] = useState<number>(itemsPerPage);

  const [page, setPage] = useState<number>(0);

  const fromPage = (
    page: number,
    itemPerPage: number,
    rows: any[] | undefined
  ) => {
    return page * itemPerPage + itemPerPage > (rows || []).length
      ? (rows || []).length
      : page * itemPerPage + itemPerPage;
  };

  useEffect(() => {
    setExpandAllRows(isToExpandAllRows);
  }, [isToExpandAllRows]);

  const [statusHelpVisible, setStatusHelpVisible] = useState(false);

  const handleOrderStatusHelp = () => {
    setStatusHelpVisible(true);
  };

  const handleRowClicking = (row: any, clickType: string) => {
    if (useModal && clickType === "details") {
      setModalVisible(true);
      setSelected(row);
    } else if (clickType === "edit") {
      handleRowClick(row);
    } else if (clickType === "delivery") {
      setDeliveryModalVisible(true);
      setSelectedDeliveryItem(row);
    } else if (clickType === "delivery_status") {
      setDeliveryStatusModal(true);
      setSelectedDeliveryItem(row);
    } else if (!useModal && clickType === "details" && operationActions) {
      operationActions(row, clickType);
    }
  };

  const headersView = (headers: any) => {
    const views: Array<any> = [];
    if (headers && !itemTracker) {
      Object.keys(headers).forEach((value, index) => {
        views.push(
          <DataTable.Title
            style={{
              flex: headers[value].width,
            }}
            key={Services.makeid(10)}
          >
            <View style={{ width: 120 }}>
              <Text
                style={{
                  fontSize: 10,
                  fontWeight: "bold",
                  width: "100%",
                  textAlign: headers[value].textAlign,
                }}
              >
                {index === 0 && isRowsExpandable && !itemTracker && (
                  <>
                    <TouchableOpacity
                      onPress={() => handleExpandableAllRowIcon()}
                    >
                      <Icon
                        name={!expandAllRows ? "plus-square" : "minus-square"}
                        size={15}
                        color={
                          headers[value].color ? headers[value].color : "black"
                        }
                      />
                    </TouchableOpacity>
                    &nbsp;&nbsp;
                  </>
                )}
                <TouchableOpacity onPress={() => handleSortColumn?.(value)}>
                  <Text
                    style={{
                      color: headers[value].color
                        ? headers[value].color
                        : "black",
                      fontWeight: headers[value].fontWeight
                        ? headers[value].fontWeight
                        : 700,
                    }}
                  >
                    {headers[value].name}
                  </Text>
                </TouchableOpacity>{" "}
                &nbsp;&nbsp;
                {headers[value].isSort && rows.length > 1 && (
                  <TouchableOpacity onPress={() => handleSortColumn?.(value)}>
                    <Icon
                      name={
                        headers[value].sortDirection === "asc"
                          ? "sort-alpha-down"
                          : "sort-alpha-up"
                      }
                      size={13}
                      color="black"
                    />
                  </TouchableOpacity>
                )}
              </Text>
            </View>
          </DataTable.Title>
        );
      });
      return views;
    }

    if (headers && itemTracker) {
      Object.keys(headers).forEach((value, index) => {
        views.push(
          <DataTable.Title
            style={{
              flex: headers[value].width,
            }}
            key={Services.makeid(10)}
          >
            <View style={{ width: 120 }}>
              <Text
                style={{
                  fontSize: 10,
                  fontWeight: "bold",
                  width: "100%",
                  textAlign: headers[value].textAlign,
                }}
              >
                {index === 0 && isRowsExpandable && !itemTracker && (
                  <>
                    <TouchableOpacity
                      onPress={() => handleExpandableAllRowIcon()}
                    >
                      <Icon
                        name={!expandAllRows ? "plus-square" : "minus-square"}
                        size={15}
                        color={
                          headers[value].color ? headers[value].color : "black"
                        }
                      />
                    </TouchableOpacity>
                    &nbsp;&nbsp;
                  </>
                )}
                <TouchableOpacity onPress={() => handleSortColumn?.(value)}>
                  <Text
                    style={{
                      color: headers[value].color
                        ? headers[value].color
                        : "black",
                      fontWeight: 700,
                      fontSize: 10,
                      // paddingLeft: index === 0 ? 30 : 0,
                    }}
                  >
                    {headers[value].name}
                  </Text>
                </TouchableOpacity>
                {/* OrderStatus help icon */}
                {headers[value].name === "Order Status" && (
                  <TouchableOpacity
                    onPress={handleOrderStatusHelp}
                    style={{ marginLeft: 2 }}
                  >
                    <Icon name="question-circle" size={12} color="gray" />
                  </TouchableOpacity>
                )}
                &nbsp;&nbsp;
                {headers[value].isSort && rows.length > 1 && (
                  <TouchableOpacity onPress={() => handleSortColumn?.(value)}>
                    <Icon
                      name={
                        headers[value].sortDirection === "asc"
                          ? "sort-alpha-down"
                          : "sort-alpha-up"
                      }
                      size={13}
                      color="black"
                    />
                  </TouchableOpacity>
                )}
              </Text>
            </View>
          </DataTable.Title>
        );
      });
      return views;
    }
  };

  const displayExpandableIcons = (
    row: any,
    expandRow: boolean,
    expandAllRows: boolean
  ): string => {
    if (!expandRow && !expandAllRows) {
      return "plus-square";
    } else if (row[rowKeyValue as string] === currentRow || expandAllRows) {
      return "minus-square";
    } else {
      return "plus-square";
    }
  };

  // Function to get status color
  const getStatusColor = (status: string) => {
    switch (status) {
      case "On Track":
      case "Shipped":
        return "#00C853"; // Green
      case "At Risk":
        return "#FFAB00"; // Orange
      case "Pending":
        return "#D32F2F"; // Red
      case "Completed":
      case "Closed":
        return "#757575"; // Gray
      default:
        return "#000"; // Default Black
    }
  };

  const getDaysLeftColor = (days: any) => {
    const dayNum = typeof days === "number" ? days : parseInt(days) || 0;

    if (dayNum < 0) {
      return "black";
    } else if (dayNum < 14) {
      return "red";
    } else if (dayNum > 60) {
      return "green";
    } else if (dayNum >= 14 && dayNum <= 60) {
      return "#FFB12B";
    } else {
      return "black"; // fallback
    }
  };

  const handleExpandableAllRowIcon = () => {
    setCurrentRow("");
    setExpandAllRows(!expandAllRows);
  };

  const handleExpandableRowIcon = (row: any, currentIcon: string) => {
    const isRowExpanded = currentIcon === "plus-square";
    setCurrentRow(row[rowKeyValue as string]);
    setExpandRow(isRowExpanded);
  };

  const cellsView = (rows: Array<any>, headers: any) => {
    const rowsViews: Array<React.ReactNode> = [];
    rows.forEach((row, index) => {
      let views: Array<React.ReactNode> = [];
      const switchToExpand =
        (expandRow || expandAllRows) &&
        (row[rowKeyValue as string] === currentRow || expandAllRows);

      Object.keys(headers).map((value, index) => {
        if (row) {
          if (!["status", "ship_status"].includes(value) && !itemTracker) {
            views.push(
              <View
                style={{
                  flex: headers[value].width,
                  borderColor: "white",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: operationsScreen
                    ? "#fff"
                    : switchToExpand
                      ? "#eee"
                      : "white",
                }}
                key={Services.makeid(10)}
              >
                {index === 0 && isRowsExpandable ? (
                  <View
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignSelf: "flex-start",
                      backgroundColor: operationsScreen
                        ? "#fff"
                        : switchToExpand
                          ? "#eee"
                          : "white",
                    }}
                  >
                    {!expandAllRows && (
                      <TouchableOpacity
                        onPress={() =>
                          handleExpandableRowIcon(
                            row,
                            displayExpandableIcons(
                              row,
                              expandRow,
                              expandAllRows
                            )
                          )
                        }
                      >
                        <Icon
                          name={displayExpandableIcons(
                            row,
                            expandRow,
                            expandAllRows
                          )}
                          size={15}
                          color={
                            operationsScreen ? "#000" : "rgb(47, 149, 220)"
                          }
                        />
                      </TouchableOpacity>
                    )}
                    <Text
                      selectable={true}
                      style={[
                        operationsScreen && { fontWeight: "500" },
                        { userSelect: "text" } as any
                      ]}
                    >
                      &nbsp;{row[value]}
                    </Text>
                  </View>
                ) : value === "" ? (
                  <View
                    style={{
                      flexDirection: "row",
                      backgroundColor: operationsScreen
                        ? "#fff"
                        : switchToExpand
                          ? "#eee"
                          : "white",
                    }}
                  >
                    {isDetail && !hideInfoIcon && (
                      <TouchableOpacity
                        onPress={() => handleRowClicking(row, "details")}
                        hitSlop={{ top: 20, bottom: 20, left: 20, right: 20 }}
                        style={{
                          padding: 12,
                          marginRight: 2,
                          minWidth: 44,
                          minHeight: 44,
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <Icon
                          name={"info-circle"}
                          size={22}
                          color={
                            operationsScreen ? "#000" : "rgb(47, 149, 220)"
                          }
                        />
                      </TouchableOpacity>
                    )}
                    {isDeliveryAttachment && (
                      <TouchableOpacity
                        style={{ cursor: "pointer" }}
                        disabled={row?.CustomerPortalOrderNo ? false : true}
                        onPress={() =>
                          handleRowClicking(row, "delivery_status")
                        }
                      >
                        <Icon
                          style={{ marginRight: "10px" }}
                          name={"truck"}
                          size={15}
                          disabled
                          color={
                            !row?.CustomerPortalOrderNo
                              ? "#DDDDDD"
                              : "rgb(47, 149, 220)"
                          }
                        />
                      </TouchableOpacity>
                    )}
                    {isDeliveryAttachment && showAttachmentIcon && (
                      <TouchableOpacity
                        onPress={() => handleRowClicking(row, "delivery")}
                        style={{ cursor: "pointer" }}
                      >
                        <Icon
                          style={{ marginRight: "5px" }}
                          name={"paperclip"}
                          size={15}
                          color={
                            operationsScreen ? "#000" : "rgb(47, 149, 220)"
                          }
                        />
                      </TouchableOpacity>
                    )}
                    {isEdit && (
                      <TouchableOpacity
                        onPress={() => handleRowClicking(row, "edit")}
                      >
                        <Icon
                          style={{ marginRight: "5px" }}
                          name={"edit"}
                          size={15}
                          color={
                            operationsScreen ? "#000" : "rgb(47, 149, 220)"
                          }
                        />
                      </TouchableOpacity>
                    )}
                    {isDelete && (
                      <TouchableOpacity
                        onPress={() =>
                          handleDeleteRow(row[rowKeyValue as string] as string)
                        }
                      >
                        <Icon name={"trash"} size={15} color="rgb(178,34,34)" />
                      </TouchableOpacity>
                    )}
                  </View>
                ) : (
                  <Text
                    style={{
                      fontSize: 12,
                      width: "100%",
                      textAlign: headers[value].textAlign,
                    }}
                    selectable={selectable ? true : false}
                  >
                    {columnsToNotHaveThousandSeparator?.includes(
                      headers[value].name
                    )
                      ? `${headers[value].name.includes("Uom1")
                        ? `${row[value]} (${row["InvntryUom"]})`
                        : headers[value].name.includes("Uom2")
                          ? `${row[value]} (${row["Uom2"]})`
                          : headers[value].name.includes("Portal")
                            ? `${row[value] ? row[value] : ""}`
                            : `${row[value]}`
                      }`
                      : formatValueAsDataType(
                        row[value],
                        isDisplayTimeWithDate
                      ) || 0}
                  </Text>
                )}
              </View>
            );
          }

          if (["status", "ship_status"].includes(value)) {
            views.push(
              <View
                style={{
                  flex: headers[value].width,
                  borderColor: "white",
                  alignItems: "flex-start",
                  justifyContent: "center",
                  backgroundColor: operationsScreen
                    ? "#fff"
                    : switchToExpand
                      ? "#eee"
                      : "white",
                }}
                key={Services.makeid(10)}
              >
                <Badge
                  label={row[value]}
                  tintColor="white"
                  color={statusColorCodes[row[value]]}
                />
              </View>
            );
          }

          if (itemTracker) {
            views.push(
              <View
                style={{
                  flex: headers[value].width,
                  borderColor: "white",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: operationsScreen
                    ? "#fff"
                    : switchToExpand
                      ? "#f8f8f8"
                      : "white",
                }}
                key={Services.makeid(10)}
              >
                {index === 0 && isRowsExpandable ? (
                  <View
                    style={{
                      flexDirection: "row",
                      alignSelf: "flex-start",
                      backgroundColor: operationsScreen
                        ? "#fff"
                        : switchToExpand
                          ? "#f8f8f8"
                          : "white",
                    }}
                  >
                    {!expandAllRows && (
                      <TouchableOpacity
                        onPress={() =>
                          handleExpandableRowIcon(
                            row,
                            displayExpandableIcons(
                              row,
                              expandRow,
                              expandAllRows
                            )
                          )
                        }
                      >
                        <Icon
                          name={displayExpandableIcons(
                            row,
                            expandRow,
                            expandAllRows
                          )}
                          size={15}
                          color={
                            operationsScreen ? "#000" : "rgb(47, 149, 220)"
                          }
                        />
                      </TouchableOpacity>
                    )}
                    <Text
                      selectable={true}
                      style={[
                        operationsScreen && { fontWeight: "500" },
                        { userSelect: "text" } as any
                      ]}
                    >
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{row[value]}
                    </Text>
                  </View>
                ) : ["progress"].includes(value) ? (
                  <CustomProgressBar progress={row[value]} />
                ) : ["delivery"].includes(value) ? (
                  <DeliveryProgressBar progress={row[value]} />
                ) : ["OrderStatus"].includes(value) ? (
                  <Text
                    style={{
                      fontSize: 12,
                      color: getStatusColor(row[value]), // Apply status color
                      fontWeight: "bold",
                      flexDirection: "row",
                      alignSelf: "flex-start",
                    }}
                  >
                    {row[value]}
                  </Text>
                ) : ["DaysLeft"].includes(value) ? (
                  <Text
                    style={{
                      fontSize: 12,
                      color: getDaysLeftColor(row[value]), // Apply status color
                      fontWeight: "bold",
                      flexDirection: "row",
                      alignSelf: "flex-start",
                    }}
                  >
                    {row[value] === 0 ? "" : row[value]}
                  </Text>
                ) : ["BPName"].includes(value) ? (
                  <Text
                    style={{
                      fontSize: 12,
                      width: "100%",
                      textAlign: ["name", "sales"].some((item) =>
                        value.toLowerCase().includes(item)
                      )
                        ? "left"
                        : ["TotalOrdered"].some((item) => value.includes(item))
                          ? "right"
                          : "left",
                      paddingRight: ["TotalOrdered"].some((item) =>
                        value.includes(item)
                      )
                        ? "50%"
                        : 0,
                      textTransform: "capitalize",
                    }}
                    onPress={() => navigatePressAction?.(value, row[value])}
                  >
                    {row[value] === 0 || row[value] == null
                      ? ""
                      : String(row[value])
                        .toLowerCase()
                        .replace(/^./, (char) => char.toUpperCase())}
                  </Text>
                ) : !["trackerActions_sm", "trackerActions"].includes(value) ? (
                  <Text
                    style={{
                      fontSize: 12,
                      width: "100%",
                      textAlign: ["name", "sales"].some((item) =>
                        value.toLowerCase().includes(item)
                      )
                        ? "left"
                        : ["TotalOrdered"].some((item) => value.includes(item))
                          ? "right"
                          : "left",
                      paddingRight: ["TotalOrdered"].some((item) =>
                        value.includes(item)
                      )
                        ? "50%"
                        : 0,
                    }}
                    onPress={() => navigatePressAction?.(value, row[value])}
                  >
                    {(() => {
                      const columnName = headers[value].name;
                      const cellValue = row[value];

                      if (
                        columnsToNotHaveThousandSeparator?.includes(columnName)
                      ) {
                        if (columnName.includes("Uom1")) {
                          return `${cellValue} (${row["InvntryUom"]})`;
                        } else if (columnName.includes("Uom2")) {
                          return `${cellValue} (${row["Uom2"]})`;
                        } else {
                          return `${cellValue}`;
                        }
                      } else if (columnName?.includes("Order Qty")) {
                        return `${cellValue?.toLocaleString()}`;
                      } else {
                        return cellValue;
                      }
                    })()}
                  </Text>
                ) : ["trackerActions_sm"].includes(value) ? (
                  <View style={{ flexDirection: "row" }}>
                    <View>
                      <Menu>
                        <MenuTrigger>
                          <View
                            style={{
                              justifyContent: "center",
                              alignContent: "center",
                              paddingLeft: 10,
                              width: 25,
                            }}
                          >
                            <Text>
                              <SimpleLineIcons
                                name="options"
                                size={18}
                                color="grey"
                              />
                            </Text>
                          </View>
                        </MenuTrigger>
                        <MenuOptions
                          optionsContainerStyle={{
                            padding: 2,
                            zIndex: 999,
                            marginLeft: -25,
                            marginTop: -10,
                            width: 140,
                          }}
                        >
                          <View style={{ flexDirection: "row" }}>
                            <View style={styles.menuOptionContainer}>
                              <MenuOption
                                style={{
                                  flex: 1,
                                  alignItems: "center",
                                }}
                                onSelect={() => operationActions?.(row, "view")}
                              >
                                <Text>
                                  <MaterialCommunityIcons
                                    name="eye"
                                    size={20}
                                    color="#5F6368"
                                    style={[styles.actionsIcons]}
                                  />
                                </Text>
                              </MenuOption>
                            </View>
                            <View style={styles.menuOptionContainer}>
                              <MenuOption
                                style={{
                                  flex: 1,
                                  alignItems: "center",
                                }}
                                onSelect={() => operationActions?.(row, "add")}
                              >
                                <Text>
                                  <MaterialCommunityIcons
                                    name="comment-outline"
                                    size={20}
                                    color="#5F6368"
                                    style={[styles.actionsIcons]}
                                  />
                                </Text>
                              </MenuOption>
                            </View>
                            <View style={styles.menuOptionContainer}>
                              <MenuOption
                                style={{
                                  flex: 1,
                                  alignItems: "center",
                                }}
                                onSelect={() =>
                                  operationActions?.(row, "history")
                                }
                              >
                                <Text>
                                  <MaterialCommunityIcons
                                    name="clock-outline"
                                    size={20}
                                    color="#5F6368"
                                    style={[styles.actionsIcons]}
                                  />
                                </Text>
                              </MenuOption>
                            </View>
                          </View>
                        </MenuOptions>
                      </Menu>
                    </View>
                  </View>
                ) : (
                  <View
                    style={{
                      borderColor: "white",
                      alignItems: "center",
                      alignSelf: "flex-start",
                    }}
                  >
                    <View style={{ flexDirection: "row" }}>
                      <TouchableOpacity
                        onPress={() => operationActions?.(row, "view")}
                      >
                        <MaterialCommunityIcons
                          name="eye"
                          size={20}
                          color="#5F6368"
                          style={[styles.actionsIcons]}
                        />
                      </TouchableOpacity>
                      <TouchableOpacity
                        onPress={() => operationActions?.(row, "add")}
                      >
                        <MaterialCommunityIcons
                          name="comment-outline"
                          size={20}
                          color="#5F6368"
                          style={[styles.actionsIcons]}
                        />
                      </TouchableOpacity>

                      <TouchableOpacity
                        onPress={() => operationActions?.(row, "history")}
                      >
                        <MaterialCommunityIcons
                          name="clock-outline"
                          size={20}
                          color="#5F6368"
                          style={[styles.actionsIcons]}
                        />
                      </TouchableOpacity>
                    </View>
                  </View>
                )}
              </View>
            );
          }
        }
      });

      if (row) {
        rowsViews.push(
          <React.Fragment key={index}>
            <DataTable.Row
              style={{
                backgroundColor: operationsScreen
                  ? "#fff"
                  : switchToExpand
                    ? "#eee"
                    : "white",
              }}
              key={`${Services.makeid(10)}_${index}`}
              onPress={
                !nestedHeader && !selectable
                  ? () => operationActions?.(row, "view")
                  : undefined
              }
            >
              {views}
            </DataTable.Row>

            {isRowsExpandable && switchToExpand && !itemTracker && (
              <NestedDataTable
                itemsPerPage={itemsPerPage}
                isNestedDataLoaded={isNestedDataLoaded}
                nestedHeader={nestedHeader}
                nestedRows={row[nestedItemKeyValue as string]}
                rowKeyValue={rowKeyValue}
                isDetail={isSubDetail}
                setModalVisible={setModalVisible}
                handleRowClick={handleRowClick}
                setSelected={setSelected}
                key="rowKeyValue"
                nestedColumnsToNotHaveThousandSeparator={
                  columnsToNotHaveThousandSeparator
                }
                isDisplayTimeWithDate={isDisplayTimeWithDate}
                handleNestedSortColumn={handleNestedSortColumn}
                disableHeader={disableHeader}
                operationActions={operationActions}
                hideInfoIcon={hideInfoIcon}
              />
            )}
          </React.Fragment>
        );
      }
    });
    return rowsViews;
  };

  return (
    <View style={{ flex: 1 }}>
      <View
        style={{
          position: "sticky",
          top: 0,
          zIndex: 1000,
          backgroundColor: "white",
        }}
      >
        <DataTable.Header>{headersView(headers)}</DataTable.Header>
      </View>

      <ScrollView style={{ flex: 1 }}>
        <OrderStatusHelp
          visible={statusHelpVisible}
          onClose={() => setStatusHelpVisible(false)}
        />
        {isDataLoading ? (
          <View>
            <Spinner
              size="small"
              color="#74BBFF"
              styles={{
                flexDirection: "row",
                marginTop: "5%",
                marginBottom: "5%",
              }}
            />
          </View>
        ) : rows.length > 0 ? (
          cellsView(
            rows.slice(
              page * _itemsPerPage,
              page * _itemsPerPage + _itemsPerPage
            ),
            headers
          )
        ) : (
          <NoDataBanner />
        )}
        <DataTable.Pagination
          page={page}
          numberOfPages={Math.ceil(rows.length / _itemsPerPage)}
          onPageChange={(page) => setPage(page)}
          label={`${fromPage(page, itemsPerPage, rows)} of ${rows.length}`}
          showFastPaginationControls
          numberOfItemsPerPage={_itemsPerPage}
          selectPageDropdownLabel={"Rows per page"}
        />
      </ScrollView>
    </View>
  );
};

const styles = StyleSheet.create({
  collapsableView: {
    flex: 1,
    borderStyle: "solid",
    borderColor: "rgba(47, 149, 220, 0.5)",
    borderWidth: 1,
  },
  actionsIcons: {
    paddingHorizontal: 8,
    cursor: "pointer",
  },
  menuOptionContainer: {
    flex: 1,
    marginHorizontal: 2,
  },
});
